import script from "./DegradoItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./DegradoItemList.vue?vue&type=script&setup=true&lang=js"

import "./DegradoItemList.vue?vue&type=style&index=0&id=7127ccb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7127ccb5"]])

export default __exports__